import React from "react"
import Styles from "./leftArea.less"
import LeftNav from "./nav/leftNav"
import LeftContent from "./content/leftContent"

const TDALeftArea = () => {
    return (
        <div className={Styles.TDA_LEFT_BOX}>
            <LeftNav />
            <LeftContent />
        </div>
    )
}

export default TDALeftArea
